(function () {
  'use strict';
  // Preserve the source's parent-row click action alongside the child's real
  // anchor href/target. Do not cancel the browser's anchor default action.
  var installed = new WeakSet();
  function init(root) {
    root.querySelectorAll('[data-native-trust-parent-href]').forEach(function (row) {
      if (installed.has(row)) return;
      var url = row.getAttribute('data-native-trust-parent-href') || '';
      if (!url) return;
      var target = row.getAttribute('data-native-trust-parent-target') || '_self';
      installed.add(row);
      row.addEventListener('click', function (event) {
        event.stopPropagation();
        window.open(url, event.ctrlKey || event.metaKey ? '_blank' : target);
      });
    });
  }
  // A section can include this asset more than once. One page-level installer
  // handles subsequent sections without installing duplicate click listeners.
  if (window.NativeTrustSourceLinks) {
    window.NativeTrustSourceLinks.init(document);
    return;
  }
  window.NativeTrustSourceLinks = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
